import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_CHANNELS } from './mutations';
import { notifications as notificationsApi } from '@/api';
import { arrayToObject } from '@/utils/helpers';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const fetchChannels = buildActionObject('fetchChannels');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [fetchChannels.action]({ commit }) {
		commit(SET_CHANNELS, arrayToObject(await notificationsApi.listChannels()));
	},
};

export default actions;
